<template>
  <div class="flex flex-wrap">
    <div class="flex flex-col w-4/12">
      <div v-if="logo" class="flex justify-center mb-8">
        <img :src="logo" />
      </div>
      <label
        class="block uppercase tracking-wide text-blue-400 text-xs font-bold mb-2 text-center"
        for="file"
      >
        Cambiar logo
      </label>
      <input
        type="file"
        accept="image/png,image/jpeg"
        id="file"
        class="hidden"
        @change="handleFileChange"
      />
    </div>
    <div class="w-8/12 pl-4 flex flex-col">
      <div class="mb-6">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="password"
        >
          Contrasena Enroll
        </label>
        <input
          type="text"
          id="password"
          class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          v-model="contrasena_enroll"
        />
      </div>
      <div class="mb-6">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="domain"
        >
          Dominio ASM
        </label>
        <input
          type="text"
          id="domain"
          class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          v-model="dominio_asm"
        />
      </div>
      <div class="mb-6">
        <label
          class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          for="domain_email"
        >
          Dominio Email
        </label>
        <input
          type="text"
          id="domain_email"
          class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          v-model="dominio_email"
        />
      </div>
    </div>
    <div class="w-full flex items-center justify-end pt-4 border-t">
      <button
        @click="submit"
        class="py-2 px-4 border border-gray-600 hover:bg-indigo-600 hover:text-white hover:border-transparent rounded focus:outline-none"
      >
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      logo: "",
      name: "",
      contrasena_enroll: "",
      dominio_asm: "",
      dominio_email: "",
      ftp_user: "",
      ftp_pass: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    ...mapActions(["getData"]),
    ...mapMutations(["hideModal"]),
    async handleFileChange(event) {
      const image = event.target.files.item(0);

      this.logo = await this.imageDataURL(image);
    },
    imageDataURL(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.addEventListener("load", () => {
          resolve(reader.result);
        });

        reader.readAsDataURL(file);
      });
    },
    submit() {
      axios
        .post("server/index.php", {
          action: "postConfiguration",
          user: this.user.num,
          colegio: this.user.colegio,
          logo: this.logo,
          contrasena_enroll: this.contrasena_enroll,
          dominio_asm: this.dominio_asm,
          dominio_email: this.dominio_email,
          ftp_server: btoa("upload.appleschoolcontent.com"),
          ftp_user: btoa(this.ftp_user.replace(/[\u0250-\ue007]/g, "")),
          ftp_pass: btoa(this.ftp_pass.replace(/[\u0250-\ue007]/g, "")),
          timestamp: Date.now(),
        })
        .then(() => {
          window.alert("Configuración guardada.");
          this.hideModal();
        });
    },
  },
  async created() {
    const group = await this.getData("getGroup");

    this.logo = group.logo;
    this.contrasena_enroll = group.contrasena_enroll;
    this.dominio_asm = group.dominio_asm;
    this.dominio_email = group.dominio_email;
    this.ftp_user = atob(group.ftp_user);
    this.ftp_pass = atob(group.ftp_pass);
  },
};
</script>
